module.exports = __webpack_public_path__ + "img/petto-di-pollo.14aff9bb.png";